import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';

import { Flex, Stack } from '@chakra-ui/react';
import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';

export default function VirtualizedList({
  getter, filterBy, filterValue, Header, cacheKey, RenderItem, shouldRefetch, setShouldRefetch,
}) {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({
    lastPage: 10,
    currentPage: 1,
    total: 10,
  });
  const infiniteLoaderRef = useRef(null);
  const listRef = useRef(null);

  const { isSuccess } = useQuery(['virtualized', cacheKey, page, shouldRefetch], () => getter({ page, [filterBy]: filterValue }), {
    cacheTime: 0,
    onSuccess: (res: AxiosResponse<any>) => {
      setData((prev) => (page === 1 ? res.data.data : [...prev, ...res.data.data]));
      setMeta(res.data.meta);
    },
  });
  const height = useMemo(() => ((data.length * 90) > 400 ? 400 : (data.length * 90)), [isSuccess]);

  useEffect(() => {
    setPage(1);
  }, [shouldRefetch]);

  return (
    <Stack>
      <Header onSuccess={() => setShouldRefetch((prev) => !prev)} />
      <Flex
        height={height}
        minHeight={data.length ? 120 : 90}
        maxHeight={400}
        overflow="hidden"
        borderRadius={8}
        shadow="inner"
        bg="gray.150"
        ref={listRef}
        p={6}>
        <InfiniteLoader
          loadMoreItems={(start, stop) => {
            if (stop - start >= 9) {
              setPage((prev) => prev + 1);
            }
          }}
          ref={infiniteLoaderRef}
          isItemLoaded={(index) => index < data.length}
          threshold={5}
          itemCount={meta.total}>
          {({ onItemsRendered, ref }) => (
            <Stack
              width="100%">
              <FixedSizeList
                itemCount={data.length}
                itemSize={70}
                itemKey={(index) => index}
                ref={ref}
                outerRef={listRef}
                onItemsRendered={onItemsRendered}
                height={height}
                style={{ minHeight: data.length ? 120 : 50, maxHeight: 400 }}
                width="100%">
                {(props) => (
                  <>
                    <RenderItem
                      {...props}
                      refetch={() => {
                        setPage(0);
                        setPage(1);
                      }}
                      data={data}
                    />
                  </>
                )}
              </FixedSizeList>
            </Stack>
          )}
        </InfiniteLoader>
      </Flex>
    </Stack>
  );
}
